// SellerOptionList?projectId=1

import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "../utilityFunction"

// Initial State
const initialState = {
    fetchSellerOption: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveSellerOption: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchSellerOptionData = createApiThunk("sellerOption", "fetch")
export const saveSellerOptionData = createApiThunk("sellerOption", "save")

// Slice
const sellerOptionSlice = createSlice({
    name: "sellerOption",
    initialState,

    reducers: {
        resetSellerState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchSellerOption = {
                    ...state.fetchSellerOption, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveSellerOption = {
                    ...state.saveSellerOption, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchSellerOptionData.pending, (state) => updateState(state, "pending", "fetchSellerOption"))
            .addCase(fetchSellerOptionData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchSellerOption", action.payload.data))
            .addCase(fetchSellerOptionData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchSellerOption", action.payload))
            // Save data
            .addCase(saveSellerOptionData.pending, (state) => updateState(state, "pending", "saveSellerOption"))
            .addCase(saveSellerOptionData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveSellerOption", action.payload.data))
            .addCase(saveSellerOptionData.rejected, (state, action) =>
                updateState(state, "rejected", "saveSellerOption", action.payload));
    },
});

export const { resetSellerState } = sellerOptionSlice.actions;
export default sellerOptionSlice.reducer;
